(function () {
  const collectionSlides = window.theCandleCollectionSlides || [
    {
      image: 'https://cdn.shopify.com/s/files/1/0933/6717/3410/files/the-candle-perfect-trio.jpg',
      alt: 'Three black candles arranged on a wooden table',
      title: 'Perfect Trio',
      text: 'Moments of magic and an atmosphere of mystery with every use.'
    },
    {
      image: 'https://cdn.shopify.com/s/files/1/0933/6717/3410/files/the-candle-candle-set.jpg',
      alt: 'Black candle set in an open box with a lit candle',
      title: 'Candle Set',
      text: 'Three atmospheric candles united in a mysterious collection.'
    },
    {
      image: 'https://cdn.shopify.com/s/files/1/0933/6717/3410/files/the-candle-candle-eye.jpg',
      alt: 'Lit black candle with eye illustration',
      title: 'The Eye',
      text: 'For those who notice.'
    },
    {
      image: 'https://cdn.shopify.com/s/files/1/0933/6717/3410/files/the-candle-candle-key.jpg',
      alt: 'Lit black candle with key illustration',
      title: 'The Key',
      text: "For what's already locked."
    },
    {
      image: 'https://cdn.shopify.com/s/files/1/0933/6717/3410/files/the-candle-candle-moon.jpg',
      alt: 'Lit black candle with moon illustration',
      title: 'The Moon',
      text: "For hours that don't keep time."
    }
  ];

  function initScrollNav() {
    const nav = document.querySelector('.site-nav');
    if (!nav) return;

    let lastScrollY = window.scrollY;
    let ticking = false;

    function updateNav() {
      const currentScrollY = window.scrollY;
      const scrollingUp = currentScrollY < lastScrollY - 4;
      const scrollingDown = currentScrollY > lastScrollY + 4;

      if (currentScrollY <= 0) {
        nav.classList.remove('is-fixed', 'is-hidden');
      } else if (scrollingUp) {
        nav.classList.add('is-fixed');
        nav.classList.remove('is-hidden');
      } else if (scrollingDown && !nav.classList.contains('site-nav--menu-open')) {
        nav.classList.add('is-hidden');
      }

      lastScrollY = Math.max(currentScrollY, 0);
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateNav);
        ticking = true;
      }
    }, { passive: true });

    updateNav();
  }

  function initMobileMenu() {
    const nav = document.querySelector('.site-nav');
    if (!nav) return;

    const toggle = nav.querySelector('.site-nav__toggle');
    const menu = nav.querySelector('.site-nav__links');
    if (!toggle || !menu) return;

    if (!menu.id) menu.id = 'site-nav-menu';
    toggle.setAttribute('aria-controls', menu.id);
    toggle.setAttribute('aria-expanded', 'false');

    function setMenuOpen(isOpen) {
      nav.classList.toggle('site-nav--menu-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    }

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      setMenuOpen(!nav.classList.contains('site-nav--menu-open'));
    });

    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) setMenuOpen(false);
    });

    document.addEventListener('click', (event) => {
      if (!nav.contains(event.target)) setMenuOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setMenuOpen(false);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1024) setMenuOpen(false);
    });
  }

  function initHeroVideoDimming() {
    const hero = document.querySelector('.page-hero--variant-2');
    if (!hero) return;

    const video = hero.querySelector('[data-hero-video]') || hero.querySelector('video.page-hero__media');
    if (!video) return;

    const startFadeSeconds = 2.5;
    const endFadeSeconds = 2.5;
    let frameId = null;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function getStartOpacity(currentTime) {
      if (currentTime >= startFadeSeconds) return 0;

      const progress = currentTime / startFadeSeconds;
      return Math.pow(1 - progress, 3);
    }

    function getEndOpacity(remainingTime) {
      if (remainingTime >= endFadeSeconds) return 0;

      const progress = 1 - (remainingTime / endFadeSeconds);
      return Math.pow(progress, 3);
    }

    function updateDimming() {
      const duration = Number.isFinite(video.duration) ? video.duration : 0;
      const currentTime = video.currentTime || 0;
      const remainingTime = duration > 0 ? duration - currentTime : Infinity;
      const opacity = clamp(Math.max(getStartOpacity(currentTime), getEndOpacity(remainingTime)), 0, 1);

      hero.style.setProperty('--hero-video-dim-opacity', opacity.toFixed(3));
    }

    function tick() {
      updateDimming();
      frameId = window.requestAnimationFrame(tick);
    }

    function startTracking() {
      if (frameId !== null) return;
      frameId = window.requestAnimationFrame(tick);
    }

    function stopTracking() {
      if (frameId === null) return;
      window.cancelAnimationFrame(frameId);
      frameId = null;
      updateDimming();
    }

    video.addEventListener('loadedmetadata', updateDimming);
    video.addEventListener('play', startTracking);
    video.addEventListener('pause', stopTracking);
    video.addEventListener('ended', stopTracking);
    video.addEventListener('seeked', updateDimming);

    updateDimming();
    if (!video.paused) startTracking();
  }

  function initProductToast() {
    const toast = document.querySelector('[data-product-toast]');
    const hero = document.querySelector('.page-hero');
    if (!toast) return;

    const cartButtons = Array.from(document.querySelectorAll('[data-static-cart-open][data-static-cart-add]')).filter((button) => {
      return !button.closest('[data-product-toast]') && !button.closest('.site-nav');
    });
    let lastScrollY = window.scrollY;
    let scrollingUp = false;
    let ticking = false;

    function isVisibleInViewport(element) {
      if (!element) return false;

      const rect = element.getBoundingClientRect();
      const style = window.getComputedStyle(element);

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.width > 0 &&
        rect.height > 0 &&
        rect.top < window.innerHeight &&
        rect.bottom > 0 &&
        rect.left < window.innerWidth &&
        rect.right > 0
      );
    }

    function isHeroVisible() {
      if (!hero) return false;

      const rect = hero.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    }

    function hasVisibleCartButton() {
      return cartButtons.some(isVisibleInViewport);
    }

    function updateScrollDirection() {
      const currentScrollY = window.scrollY;

      if (currentScrollY < lastScrollY - 4) {
        scrollingUp = true;
      } else if (currentScrollY > lastScrollY + 4) {
        scrollingUp = false;
      }

      lastScrollY = Math.max(currentScrollY, 0);
    }

    function updateToast() {
      toast.classList.toggle('is-visible', scrollingUp && !isHeroVisible() && !hasVisibleCartButton());
    }

    function requestToastUpdate(trackScrollDirection) {
      if (ticking) return;

      window.requestAnimationFrame(() => {
        if (trackScrollDirection) updateScrollDirection();
        updateToast();
        ticking = false;
      });
      ticking = true;
    }

    window.addEventListener('scroll', () => requestToastUpdate(true), { passive: true });
    window.addEventListener('resize', () => requestToastUpdate(false));
    updateToast();
  }

  function createLightbox() {
    const lightbox = document.createElement('div');
    lightbox.className = 'image-lightbox';
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.innerHTML = [
      '<button class="image-lightbox__close" type="button" aria-label="Close image"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.6539 14.8492L14.8543 15.6489L0.00504911 0.799638L0.804688 0L15.6539 14.8492Z" fill="#2F2822"/><path d="M14.8492 0.00232035L15.6489 0.801959L0.799638 15.6512L0 14.8516L14.8492 0.00232035Z" fill="#2F2822"/></svg></button>',
      '<img class="image-lightbox__image" alt="">'
    ].join('');
    document.body.appendChild(lightbox);
    return lightbox;
  }

  function initGallery() {
    const galleryImage = document.querySelector('[data-gallery-image]') || document.querySelector('.collection__main-image img');
    const galleryTitle = document.querySelector('[data-gallery-title]');
    const galleryText = document.querySelector('[data-gallery-text]');
    const prevButton = document.querySelector('[data-gallery-prev]');
    const nextButton = document.querySelector('[data-gallery-next]');
    const lightboxOpen = document.querySelector('[data-lightbox-open]');
    if (!galleryImage || !lightboxOpen) return;

    const lightbox = createLightbox();
    const lightboxImage = lightbox.querySelector('.image-lightbox__image');
    const lightboxClose = lightbox.querySelector('.image-lightbox__close');
    let activeIndex = 0;
    let pointerStartX = 0;
    let pointerStartY = 0;
    let pointerTracking = false;
    let swipeHandled = false;
    let suppressNextClick = false;

    function setSlide(index) {
      const normalizedIndex = (index + collectionSlides.length) % collectionSlides.length;
      const slide = collectionSlides[normalizedIndex];
      if (!slide) return;

      activeIndex = normalizedIndex;
      galleryImage.removeAttribute('srcset');
      galleryImage.removeAttribute('sizes');
      galleryImage.src = slide.image;
      galleryImage.alt = slide.alt;
      if (galleryTitle) galleryTitle.textContent = slide.title;
      if (galleryText) galleryText.textContent = slide.text;
    }

    function isSwipeEnabled(event) {
      return event.pointerType === 'touch' || window.matchMedia('(max-width: 1024px)').matches;
    }

    function beginSwipe(event) {
      if (!isSwipeEnabled(event)) return;

      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      pointerTracking = true;
      swipeHandled = false;

      if (lightboxOpen.setPointerCapture) {
        lightboxOpen.setPointerCapture(event.pointerId);
      }
    }

    function moveSwipe(event) {
      if (!pointerTracking || swipeHandled) return;

      const deltaX = event.clientX - pointerStartX;
      const deltaY = event.clientY - pointerStartY;
      const isHorizontalSwipe = Math.abs(deltaX) > 44 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25;

      if (!isHorizontalSwipe) return;

      swipeHandled = true;
      suppressNextClick = true;
      setSlide(activeIndex + (deltaX < 0 ? 1 : -1));
    }

    function endSwipe(event) {
      if (!pointerTracking) return;

      pointerTracking = false;

      if (lightboxOpen.releasePointerCapture && lightboxOpen.hasPointerCapture && lightboxOpen.hasPointerCapture(event.pointerId)) {
        lightboxOpen.releasePointerCapture(event.pointerId);
      }
    }

    function openLightbox() {
      lightboxImage.src = galleryImage.currentSrc || galleryImage.src;
      lightboxImage.alt = galleryImage.alt;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('is-lightbox-open');
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('is-lightbox-open');
    }

    if (prevButton) {
      prevButton.addEventListener('click', () => setSlide(activeIndex - 1));
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => setSlide(activeIndex + 1));
    }

    lightboxOpen.addEventListener('pointerdown', beginSwipe);
    lightboxOpen.addEventListener('pointermove', moveSwipe);
    lightboxOpen.addEventListener('pointerup', endSwipe);
    lightboxOpen.addEventListener('pointercancel', endSwipe);
    lightboxOpen.addEventListener('click', (event) => {
      if (suppressNextClick) {
        event.preventDefault();
        event.stopPropagation();
        suppressNextClick = false;
        return;
      }

      openLightbox();
    });
    lightboxClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeLightbox();
    });
  }

  function initReviewsCarousel() {
    document.querySelectorAll('[data-reviews-carousel]').forEach((carousel) => {
      const list = carousel.querySelector('[data-reviews-list]');
      const prevButton = carousel.querySelector('.reviews__arrow--prev');
      const nextButton = carousel.querySelector('.reviews__arrow--next');
      if (!list || !prevButton || !nextButton) return;

      function getStep() {
        const card = list.querySelector('.reviews__card');
        if (!card) return list.clientWidth;

        const styles = window.getComputedStyle(list);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        const maxScroll = Math.max(0, list.scrollWidth - list.clientWidth - 1);
        prevButton.disabled = list.scrollLeft <= 1;
        nextButton.disabled = list.scrollLeft >= maxScroll;
      }

      prevButton.addEventListener('click', () => {
        list.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        list.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      list.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  function initBenefits() {
    const items = Array.from(document.querySelectorAll('[data-benefit-item]'));
    const pictures = Array.from(document.querySelectorAll('[data-benefit-picture]'));
    if (!items.length) return;

    function setActivePicture(index) {
      pictures.forEach((picture) => {
        const isActive = picture.dataset.benefitPicture === index;
        picture.classList.toggle('benefits__picture--active', isActive);
        picture.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    items.forEach((item) => {
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-expanded', item.classList.contains('benefits__item--active') ? 'true' : 'false');

      function activate() {
        const activeIndex = item.dataset.benefitItem;

        items.forEach((entry) => {
          const isActive = entry === item;
          entry.classList.toggle('benefits__item--active', isActive);
          entry.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });

        setActivePicture(activeIndex);
      }

      item.addEventListener('click', activate);
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activate();
        }
      });
    });

    const activeItem = items.find((item) => item.classList.contains('benefits__item--active')) || items[0];
    if (activeItem) setActivePicture(activeItem.dataset.benefitItem);
  }

  function initFaq() {
    const items = Array.from(document.querySelectorAll('[data-faq-item]'));
    if (!items.length) return;

    items.forEach((item) => {
      const question = item.querySelector('.faq__question');
      if (!question) return;

      question.addEventListener('click', () => {
        const isOpen = item.classList.toggle('faq__item--open');
        question.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initScrollNav();
    initMobileMenu();
    initHeroVideoDimming();
    initProductToast();
    initGallery();
    initReviewsCarousel();
    initBenefits();
    initFaq();
  });
}());
